"use strict";

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

function sleep() {
  return {
    name: 'sleep',
    synopsis: 'sleep [SECONDS]',
    description: 'Wait for a specified amount of time',
    execute: function execute(_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          seconds = _ref2[0];

      return new Promise(function (resolve) {
        setTimeout(function () {
          return resolve();
        }, seconds * 1000);
      });
    }
  };
}

var _default = sleep;
exports.default = _default;